import React from 'react';
import {
  Box,
  createStyles,
  Theme,
  Typography,
  withStyles,
} from '@material-ui/core';
import aulaLogo from '../../../../static/aulaLogo.png';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      minHeight: 'calc(100vh - 80px)',
      boxSizing: 'border-box' as const,
      padding: theme.spacing(5, 0),
      maxWidth: '990px',
      width: '100%',
      margin: '0 auto',
    },
    wrapper: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: theme.spacing(2),
      padding: theme.spacing(4),
      backgroundColor: theme.palette.background.default || '#fafafa',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      paddingBottom: theme.spacing(1.5),
      marginBottom: theme.spacing(1),
      borderBottom: '1px solid rgba(35, 31, 41, 0.16)',
    },
    logo: {
      height: 18,
      width: 'auto' as const,
    },
    title: {
      fontWeight: 400,
      color: theme.palette.text.primary,
    },
  });

const RolePageContainer = ({ title, children, classes }) => {
  return (
    <Box className={classes.container}>
      <Box className={classes.wrapper}>
        {/* Header Section */}
        <Box className={classes.header}>
          <img src={aulaLogo} alt="Aula Logo" className={classes.logo} />
          <Typography variant="h6" className={classes.title}>
            - {title}
          </Typography>
        </Box>

        {children}
      </Box>
    </Box>
  );
};

export default withStyles(styles, { withTheme: true })(RolePageContainer);
